import {
    isThumbnailViewLinkBasedOnId,
    OUTLOOK_THUMBNAIL_VIEW_LINK_ATTRIBUTE,
    OUTLOOK_THUMBNAIL_VIEW_LINK_ATTRIBUTE_VALUE,
} from 'owa-attachment-link-common';
export function isThumbnailViewLink(element: HTMLElement, isHTMLPaste: boolean) {
    if (isHTMLPaste) {
        // During paste, the id would be stripped off to avoid duplication
        return (
            element.getAttribute(OUTLOOK_THUMBNAIL_VIEW_LINK_ATTRIBUTE) ===
            OUTLOOK_THUMBNAIL_VIEW_LINK_ATTRIBUTE_VALUE
        );
    } else {
        return isThumbnailViewLinkBasedOnId(element);
    }
}
